/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterIdNameModel {
    getFixupPrototypeFunction() { return FilterIdNameModel.fixupPrototype; }

    static newInstance(model: Partial<FilterIdNameModel>): FilterIdNameModel {
        let obj = Object.assign(new FilterIdNameModel(), model);
        FilterIdNameModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterIdNameModel>): FilterIdNameModel {
        if (!model) return null;
        return FilterIdNameModel.newInstance(<FilterIdNameModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterIdNameModel) {
        if (!obj) return;

        models.FilterIdNameModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterIdNameModel): boolean {
        Object.setPrototypeOf(obj, FilterIdNameModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of filter key
     */
    id: string;

    /**
     * Id of filter name
     */
    name: string;

}
